import barba from '@barba/core';
import gsap from 'gsap';
import scrollToTop from './scrollToTop';
import { loaderIn, loaderAway } from './loader';
import { reloadWpAdminBar } from './wpadminbar';
import { closeMaxMegaMenu } from './megaMenu-close';
import { preserveGravityFormsStylesheet, reinitGravityForms } from './gravity-forms-loader.js';
/////////////////////////////////////////////////////////////////
import { initFaqAccordion } from '../blocks/faq.js';
import { playHomeHeroVideo } from './homeHeroVideo';
import { initApplicationListSliders } from '../blocks/application-list.js';
import { initGalleryLightbox } from '../blocks/gallery-lightbox.js';
import { initCaseStudyShuffle } from '../shufflejs.js';
import { initCaseStudySliders } from '../blocks/case-study-slider.js';

export function initializeBarba() {

  barba.init({
    debug: true,
    transitions: [
      {
        name: 'general-transition',
        once: ({ next }) => {
        },
        async leave() {
          await loaderIn();
        },
        async enter() {
          await scrollToTop();
          loaderAway();
        }
      },
    ],
    prevent: ({ el, event, href }) => {
      const a = el?.closest ? el.closest('a') : null;
      if (!a) return false;

      // 1) Skip GLightbox triggers
      if (a.matches('.glightbox,[data-glightbox]')) return true;

      // 2) Skip anything explicitly flagged
      if (a.hasAttribute('data-barba-prevent') || a.hasAttribute('data-no-barba')) return true;

      // (optional) also skip in-page anchors, mailto, tel
      if (href && (/^#/.test(href) || /^mailto:/i.test(href) || /^tel:/i.test(href))) return true;

      // Skip if link is inside WP Admin Bar
      if (el.closest('#wpadminbar')) return true;

      // Skip if it's a WordPress admin link
      if (href && href.startsWith('/wp-admin')) return true;

      return false;
    },
  });


  //*****************************************************************************************************
  // Barba Hooks for all namespaces
  barba.hooks.before(() => {

    document.querySelector('html').classList.add('is-transitioning');
    barba.wrapper.classList.add('is-animating');

  });

  barba.hooks.afterLeave(() => {

    closeMaxMegaMenu();

  });

  barba.hooks.after(() => {

    document.querySelector('html').classList.remove('is-transitioning');
    barba.wrapper.classList.remove('is-animating');

  });

  barba.hooks.beforeEnter(({ next }) => {
    preserveGravityFormsStylesheet(next);
  });

  barba.hooks.enter(() => {
    reloadWpAdminBar();
  });

  barba.hooks.afterEnter((data) => {
    initFaqAccordion(data.next.container);
    playHomeHeroVideo(data.next.container);
    initApplicationListSliders(data.next.container);
    initGalleryLightbox(data.next.container);
    initCaseStudyShuffle(data.next.container);
    initCaseStudySliders(data.next.container);
    reinitGravityForms(data.next.container);
  });
}
